export default "__VITE_ASSET__8ab7dc6c__"